
import { Switch } from "@headlessui/react";
import classNames from "../../../utils/classNames";
import React from "react";
import { FieldValues, Path, RegisterOptions, UseFormRegister, UseFormSetValue, UseFormWatch } from "react-hook-form";

interface StyledSwitchInputProps<T extends FieldValues> extends Omit<React.HTMLProps<HTMLInputElement>, 'onChange'> {
  register: UseFormRegister<T>;
  registerName: Path<T>;
  setValue: UseFormSetValue<T>;
  watch: UseFormWatch<T>;
  onChange?: (checked: boolean) => void;
  label?: string;
  registerOptions?: RegisterOptions<T, Path<T>>;
  column?: boolean;
  classes?: string;
  labelClasses?: string; // Tailwind CSS margin classes
}

export default function StyledSwitchInput<T extends FieldValues>({
  register,
  registerName,
  registerOptions,
  setValue,
  watch,
  label,
  column = false,
  classes = "",
  labelClasses = "",
  onChange,
}: StyledSwitchInputProps<T>) {

  const watchToggle = Boolean(watch(registerName));

  return (
    <div className={classes}>
      <Switch.Group as="div" className={classNames(
        column ? "flex flex-col gap-y-2" : "flex items-center space-x-4",
      )}>
        {label &&
          <span className={labelClasses}>
            <Switch.Label as="span" className="text-sm font-medium text-gray-900" passive>
              {label}
            </Switch.Label>
          </span>
        }
        <Switch
          {...register(registerName, registerOptions)}
          checked={watchToggle}
          onChange={(checked: boolean) => {
            setValue(registerName, checked as any, { shouldDirty: true })
            onChange?.(checked);
          }}
          className={classNames(
            watchToggle ? 'bg-etpink-600' : 'bg-gray-200',
            'relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-etpink-500'
          )}
        >
          <span
            aria-hidden="true"
            className={classNames(
              watchToggle ? 'translate-x-5' : 'translate-x-0',
              'pointer-events-none inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200'
            )}
          />
        </Switch>
      </Switch.Group>
    </div>
  )
}